import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useToast } from "native-base";
import React from "react";

import Toast from "@/components/atoms/Toast";
import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppSelector } from "@/hooks/application/store";
import { ApiError } from "@/interfaces/common/Error";
import { changePassword } from "@/services/api/user";
import { logger } from "@/services/logger";

import ChangePasswordMobile from "./ChangePassword.mobile";
import ChangePasswordWeb from "./ChangePassword.web";
import { ChangePasswordFormData } from "./schema";

const ChangePassword = () => {
  const { isWebMode } = useViewport();
  const { goBack } = useAppNavigation();
  const toast = useToast();

  const { user } = useAppSelector((store) => store.auth);

  const { mutate, isLoading } = useMutation<void, AxiosError<ApiError>, string>({
    mutationFn: (data) => changePassword(user._id, data),
    onSuccess: (data) => {
      toast.show({
        render: () => <Toast variant="success" message="Senha alterada com sucesso!" />,
      });
      goBack();
    },
    onError: (error) => {
      logger.error(error);
      toast.show({
        render: () => <Toast variant="error" message={error.response.data.error} />,
      });
    },
  });

  const onSubmit = (data: ChangePasswordFormData) => {
    mutate(data.password);
  };

  const Screen = isWebMode ? ChangePasswordWeb : ChangePasswordMobile;

  return <Screen isSubmiting={isLoading} onCancel={goBack} onSubmit={onSubmit} />;
};

export default ChangePassword;
